export default __webpack_public_path__ + "static/media/arff.43e64120.png";